export default [
  {
    path: '/IFPageOneHSixtyEightPreLogin',
    name: 'IFPageOneHSixtyEightPreLogin',
    meta: {
      title: '贷款匹配',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/preLogin.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightLogin',
    name: 'pageOneHSixtyEightLogin',
    meta: {
      title: '等待接听',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/login.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightLoginLoading',
    name: 'pageOneHSixtyEightLoginLoading',
    meta: {
      title: '落地页',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightLeaveInfo',
    name: 'pageOneHSixtyEightLeaveInfo',
    meta: {
      title: '落地页',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightResult',
    name: 'pageOneHSixtyEightResult',
    meta: {
      title: '专享额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/result.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightLoading',
    name: 'pageOneHSixtyEightLoading',
    meta: {
      title: '申请提交中',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/loading.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightNoProducts',
    name: 'pageOneHSixtyEightNoProducts',
    meta: {
      title: '暂无产品',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/noProducts.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightLoginSecond',
    name: 'pageOneHSixtyEightLoginSecond',
    meta: {
      title: '落地页',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/loginSecond.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightOnline',
    name: 'pageOneHSixtyEightOnline',
    meta: {
      title: '落地页',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/online.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightGuide',
    name: 'pageOneHSixtyEightLoginGuide',
    meta: {
      title: '下载',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/guide.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightBlank',
    name: 'pageOneHSixtyEightBlank',
    meta: {
      title: '落地页',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/blank.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightOnlineTab',
    name: 'pageOneHSixtyEightOnlineTab',
    meta: {
      title: '落地页',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/onlineTab.vue'),
  },
  {
    path: '/IFPageOneHSixtyEightOnlineAd',
    name: 'pageOneHSixtyEightOnlineAd',
    meta: {
      title: '落地页',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyEight/onlineAd.vue'),
  },
];
